import { render, staticRenderFns } from "./ObjectSro.vue?vue&type=template&id=53157364&scoped=true"
import script from "./ObjectSro.vue?vue&type=script&lang=js"
export * from "./ObjectSro.vue?vue&type=script&lang=js"
import style0 from "./ObjectSro.vue?vue&type=style&index=0&id=53157364&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53157364",
  null
  
)

export default component.exports